<script>
import { symptomCheckerService } from './../../../../../services/safehaven/SymptomCheckerService'
export default {
  page: {
    title: 'Health Check',
    meta: [{ name: 'description', content: 'The Symptom Checker page.' }],
  },
  data() {
    return {
      infermedicaURL: null,
    }
  },
  computed: {
    url() {
      return this.infermedicaURL
    },
  },
  mounted() {
    this.getSymptomCheckerURL()
  },
  methods: {
    getSymptomCheckerURL() {
      symptomCheckerService.getInfermedicaURL().then(
        (res) => {
          this.infermedicaURL = res.data.url
        },
        (err) => {
          console.warn(err.response.data.message)
        }
      )
    },
  },
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        :class="[
          $style.heightClss,
          $vuetify.breakpoint.smAndDown ? 'pt-0 pb-2' : '',
          $vuetify.breakpoint.xs ? 'pt-6 pb-2' : '',
        ]"
      >
        <iframe
          v-if="url"
          id="sc-iframe"
          :src="url"
          frameborder="0"
          :class="[
            $style.noBorder,
            $vuetify.breakpoint.smAndDown ? 'mt-1' : ' ',
          ]"
          title="Symptom Checsker"
        ></iframe>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.noBorder {
  position: relative;
  width: 100% !important;
  min-height: 810px;
}
@media screen and (max-width: 799px) {
  .heightClss {
    height: 90vh;
  }
  .noBorder {
    min-height: 88vh;
  }
}
@media screen and (max-width: 430px) {
  .heightClss {
    height: 80vh;
  }
  .noBorder {
    min-height: 78vh;
  }
}
@media screen and (max-width: 360px) {
  .heightClss {
    height: 80vh;
  }
  .noBorder {
    min-height: 78vh;
  }
}
</style>
